import React from "react";
import {TableBody, TableCell} from "@mui/material";
import TableRow from "@mui/material/TableRow";


export const ErrorBody = ({columCounter, rowsPerPage}) => {
	return (
		<TableBody>
			<TableRow>
				<TableCell colSpan={columCounter} rowSpan={rowsPerPage}>
					Errore nel caricamento dei dati
				</TableCell>
			</TableRow>
		</TableBody>
	);
}
